import React from "react";
import { LocaleProvider } from "./LocaleContext";

// Shared between gatsby-browser.js and gatsby-ssr.js so the SSR and client
// element trees match exactly (Gatsby requires this for wrapRootElement).
export const wrapRootElement = ({ element }) => (
  <LocaleProvider>{element}</LocaleProvider>
);
